/** Resolve a list item by numeric id or business code. */

export function findByIdOrCode(items, param, { idKey = 'id', codeKey } = {}) {
  if (param == null || param === '' || !Array.isArray(items)) return null;
  const raw = String(param);
  const asNum = Number(raw);
  if (Number.isFinite(asNum) && String(asNum) === raw) {
    const byId = items.find((item) => Number(item?.[idKey]) === asNum);
    if (byId) return byId;
  }
  if (codeKey) {
    return items.find((item) => String(item?.[codeKey]) === raw) || null;
  }
  return null;
}

export async function loadByIdOrCode({
  param,
  listFn,
  getFn,
  codeKey,
  listParams = {},
}) {
  if (param == null || param === '') return null;
  const raw = String(param);
  const asNum = Number(raw);
  if (Number.isFinite(asNum) && String(asNum) === raw && getFn) {
    try {
      return await getFn(asNum);
    } catch {
      /* fall through to list lookup */
    }
  }
  // Resolve business codes with a narrow search — never pageSize=200 “load all”.
  const result = await listFn({
    page: 1,
    pageSize: 10,
    search: raw,
    ...listParams,
  });
  const items = result?.items || [];
  const found = findByIdOrCode(items, raw, { codeKey });
  if (!found) return null;
  if (found.id != null && getFn) {
    try {
      return await getFn(found.id);
    } catch {
      return found;
    }
  }
  return found;
}

export function dbIdForCode(items, code, { codeKey, idKey = 'id' } = {}) {
  if (!code || !Array.isArray(items)) return null;
  const row = items.find((item) => String(item?.[codeKey]) === String(code));
  return row?.[idKey] ?? null;
}
